// Package
export default defineNuxtPlugin((nuxtApp) => {
  let bindingInstance!: any;

  const inputHandler = (event: any) => bindingInstance.value = event.target.value;

  nuxtApp.vueApp.directive('model-nfw', {
    created(el, binding, _globalThis) {
      bindingInstance = binding;

      el.value = binding.value;
      el.addEventListener('input', inputHandler);
    },

    updated(el, binding, vnode) {
      el.value = binding.value;
    },

    unmounted(el) {
      el.removeEventListener('input', inputHandler);
    },
  });
});
